import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import UserPanelAllCourses from '../../Components/UserPanelAllCourses/UserPanelAllCourses'
import UserPanelSideControl from '../../Components/UserPanelSideControl/UserPanelSideControl'
import {Switch,Route, useRouteMatch} from 'react-router-dom'
import Style from './Index.module.css'
import CourseLisence from '../../Components/CourseLisence/CourseLisence'
import AddCommentUserPanel from '../../Components/AddCommentUserPanel/AddCommentUserPanel'

const Index = () => {
    const[show,setShow]=useState(false)
    let { path } = useRouteMatch();

    return (
        <div className='pageHolder'>
            <div className={Style.UserHeader}>خوش آمدید
            <FontAwesomeIcon icon={faBars} className={Style.BtnMenu} onClick={()=>setShow(true)}/>
            </div>
            <section className={Style.LayoutHolder}>
                <div className={Style.PageContent}>
                    <Switch>
                        <Route exact path={`${path}/comment/:id`} component={AddCommentUserPanel}/>
                        <Route exact  path={path} component={CourseLisence}/>
                        <Route exact  path={`${path}/allcourse`}><UserPanelAllCourses/></Route>  
                    </Switch>
                </div>
                <UserPanelSideControl show={show} setShow={setShow}/>
            </section>
        </div>
    )
}

export default Index
